export default "__VITE_ASSET__81ac7c0a__"